<template lang="pug">
    .gallery
        .item(v-for="(slide, ind) in slides"
            :style="{backgroundImage: 'url('+slide.img+')'}"
            @click="activeItem=ind")
        transition
            .info(v-if="activeItem!==null")
                Closer(@click.native="activeItem=null")
                .img(:style="{backgroundImage: 'url('+slides[activeItem].img+')'}")
                .text
                    h3(v-html="slides[activeItem].title")
                    span(v-html="slides[activeItem].text")
</template>

<script>
    export default {
        name: "IcebreakerGallery",
        props:['slides'],
        data:()=>({
            activeItem: null,
        }),
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";

    .gallery{
        position: relative;
        display: flex;
        flex-wrap: wrap;
        width: calc(100vw + 2px);
        background: #fff;
    }
    .item{
        width: calc(100vw / 3 - 1.5px);
        height: calc(100vw / 3 - 1.5px);
        margin-bottom: 2px;
        margin-right: 2px;
        background: no-repeat center center / cover;
    }
    .info{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        background: rgba($blue, 0.9);
        overflow: auto;
        .close-button{
            position: absolute;
            top: 2.5vw;
            right: 3.5vw;
        }
        .img{
            height: 100%;
            background: no-repeat center center / cover;
        }
        .text{
            max-height: 30%;
            padding: 4.5vw 5vw 6vw;
            font-size: 4.55vw;
            line-height: 1.2;
            text-align: center;
            color: #fff;
            h3{
                margin-bottom: 3vmin;
                font-size: 5vmin;
                text-transform: uppercase;
            }
            span{
                display: block;
                padding-bottom: 8vmin;
                font-family: "Fira Sans Extra Condensed", sans-serif;
                font-size: 4vw;
                line-height: 1.34;
            }
        }
    }
    .v-enter{
        opacity: 0;
        transform: translateY(5vw);
    }
    .v-enter-active{
        transition: .3s;
    }
    .v-leave-active{
        opacity: 0;
        transform: translateY(5vw);
        transition: .3s;
    }
</style>
